<main>
  <caixa-webcomponent-navigation-bar />

  <header
    class="investments-header notification"
  >
    <caixa-webcomponent-main-title text="Investimentos" [lastUpdate]="lastUpdate" />
  </header>

  <div class="cards-grid">
    <div class="cards-column">
      <div class="cds-card card-item card-total-balance">
        <div class="card-header">
          <h4 class="card-title">
            Saldo total atual investido
            <i
              class="cds-icon-filled-question c-icon-strong"
              [cdsTooltip]="'Valor total aplicado, somando todos os investimentos, sem considerar nenhum desconto de taxa ou imposto.'"
              placement="top"
            >
            </i>
          </h4>
        </div>

        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="120px"
            height="32px"
            borderRadius="4px"
          />
        } @else {
          <span
            class="card-value"
            [class]="cashIndicatorClass(data.cards.totalBalance, 'credit')"
          >R$ {{ signedCash(data.cards.totalBalance, 'credit') | formatCash }}</span>
        }
      </div>

      <div class="cds-card card-item card-fees">
        <div class="card-header">
          <h4 class="card-title">Taxas e Impostos provisionados</h4>
        </div>

        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100px"
            height="32px"
            borderRadius="4px"
          />
        } @else {
          <span
            class="card-value"
            [class]="cashIndicatorClass(data.cards.feesTaxes, 'debit')"
          >R$ {{ signedCash(data.cards.feesTaxes, 'debit') | formatCash }}</span>
        }
      </div>
    </div>

    <div class="cds-card card-item card-types">
      <div class="card-header">
        <h4 class="card-title">Saldo investido por Tipo de Investimento</h4>
      </div>

      <div class="card-content">
        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100%"
            height="60px"
            borderRadius="8px"
            marginBottom="2px"
            [lines]="3"
          />
        } @else {
          <div class="types-list">
            @for (item of data.cards.balanceByType; track item.type) {
              <div class="type-item">
                <div
                  class="type-bar"
                  [style.background-color]="item.color"
                ></div>

                <div class="type-name-container">
                  <span class="type-name">{{ item.type }}</span>
                </div>

                <div class="type-value-container">
                  <span
                    class="type-value"
                    [class]="cashIndicatorClass(item.balance, 'credit')"
                  >R$ {{ signedCash(item.balance, 'credit') | formatCash }}</span>
                  <i
                    class="cds-icon-filled-question c-icon-strong"
                    [cdsTooltip]="item.tooltip"
                    placement="top"
                  >
                  </i>
                </div>
              </div>
            } @empty {
              <span>Não encontramos investimentos vinculados ao seu CNPJ até o momento.</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="cds-card card-item card-institutions">
      <div class="card-header">
        <h4 class="card-title">Saldo investido por Instituição Financeira</h4>
      </div>

      <div class="card-content">
        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100%"
            height="60px"
            borderRadius="8px"
            marginBottom="2px"
            [lines]="2"
          />
        } @else {
          <div class="institutions-list">
            @for (item of data.cards.balanceByInstitution; track item.institution) {
              <div class="institution-item">
                <div
                  class="institution-bar"
                  [style.background-color]="item.color"
                ></div>
                <span class="institution-name">{{ item.institution }}</span>
                <span
                  class="institution-value"
                  [class]="cashIndicatorClass(item.balance, 'credit')"
                >R$ {{ signedCash(item.balance, 'credit') | formatCash }}</span>
              </div>
            } @empty {
              <span>Não encontramos investimentos vinculados ao seu CNPJ até o momento.</span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="cds-card card-item">
    <div class="tabs-container">
      <caixa-webcomponent-tabs-navigation
        [config]="tabsConfig"
        [activeTab]="activeTab"
        (tabChange)="onTabChange($event)"
      />
    </div>

    <div
      class="table-section"
      [class.variable-income-table]="activeTab === 'renda-variavel'"
      [scrollPercent]="25"
      (infiniteScrolling)="onInfiniteScroll()"
    >
      <caixa-webcomponent-data-table
        [data]="tableData"
        [config]="tableConfig"
        [actions]="currentTableActions"
        [loading]="isLoadingInvestments()"
        (sortChange)="onSortChange($event)"
        (rowClick)="onRowClicked($event)"
      />
    </div>

    @if (isLoadingMoreInvestments()) {
      <caixa-webcomponent-shimmer
        width="100%"
        height="60px"
        borderRadius="8px"
        marginBottom="2px"
        [lines]="3"
      />
    }

    @if (showListEndIndicator) {
      <div class="list-end-indicator">
        <cds-no-content [isListEnd]="true" />
      </div>
    }
  </div>
</main>
